import { useState } from "react";
import "./contact.css";
import contactBg from "../assets/img/contact-bg.mp4"; // background video
import { db } from "../confiq/firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await addDoc(collection(db, "contacts"), {
        name,
        email,
        subject,
        message,
        createdAt: Timestamp.now()
      });
      alert("Message sent successfully!");
      setName("");
      setEmail("");
      setSubject("");
      setMessage("");
    } catch (error) {
      console.error("Error adding document: ", error);
      alert("Error sending message!");
    }

    setLoading(false);
  };
  return (
    <section className="contact-section">
      {/* 🔹 Background Video */}
      <video className="contact-bg" autoPlay loop muted playsInline>
        <source src={contactBg} type="video/mp4" />
      </video>

      {/* 🔹 Overlay */}
      <div className="contact-overlay"></div>

      {/* 🔹 Header */}
      <div className="contact-header">
        <h2 className="contact-title">Let’s Build Something Great Together 💼</h2>
        <h3 className="typewriter-text">Innovate. Inspire. Grow with MarketMind4U 🚀</h3>
        <p className="contact-subtitle">
          Reach out to <strong>MarketMind4U</strong> — where creativity, technology, and
          strategy come together to build your brand’s future.
        </p>
      </div>

      {/* 🔹 Vision & Mission Section */}
      <div className="vision-mission-section">
        <div className="vision-card">
          <h3>🌟 Our Vision</h3>
          <p>
            To revolutionize digital marketing through <strong>AI-driven strategy</strong>,
            making every business—big or small—accessible, scalable, and globally competitive.
            We dream of an India where every entrepreneur grows smart and fast.
          </p>
        </div>

        <div className="mission-card">
          <h3>🎯 Our Mission</h3>
          <p>
            To empower brands with <strong>innovative solutions</strong> that connect emotionally
            with their audience. We strive to deliver measurable growth through
            <strong> performance marketing, design excellence,</strong> and continuous innovation.
          </p>
        </div>
      </div>

      {/* 🔹 Contact Info & Form */}
      <div className="contact-container">
        <div className="contact-grid">
          {/* Left Side - Info */}
          <div className="contact-info">
            <h3>Contact Information</h3>
            <p><i className="fa fa-map-marker-alt"></i> G07, H-61, Sector-63, Noida, India</p>
            <p><i className="fa fa-phone"></i> +91 7906576404</p>
            <p><i className="fa fa-envelope"></i> info@marketmind4u.com</p>

            <div className="contact-social">
              <a href="#"><i className="fab fa-facebook-f"></i></a>
              <a href="#"><i className="fab fa-linkedin-in"></i></a>
              <a href="#"><i className="fab fa-twitter"></i></a>
              <a href="#"><i className="fab fa-youtube"></i></a>
            </div>
          </div>

          {/* Right Side - Form */}
          <div className="contact-form">
            <h3>Send Us a Message</h3>
            <form onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Your Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />
      <input
        type="email"
        placeholder="Your Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <input
        type="text"
        placeholder="Subject"
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
      />
      <textarea
        rows="4"
        placeholder="Your Message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        required
      ></textarea>
      <button type="submit" className="contact-btn" disabled={loading}>
        {loading ? "Sending..." : "Send Message"}
      </button>
    </form>
          </div>
        </div>
      </div>

      {/* 🔹 Google Map */}
      <div className="map-container">
        <iframe
          title="MarketMind4U Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14018.673520829558!2d77.3774!3d28.6283!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce554a3d61d4b%3A0x23d957cbf4f4c9aa!2sNoida%20Sector%2063!5e0!3m2!1sen!2sin!4v1709456000000"
          width="100%"
          height="400"
          style={{ border: "none" }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </section>
  );
};

export default Contact;
